import React, { useState } from "react";
import { makeStyles, Tooltip } from "@material-ui/core";
import { Body } from "@components";
import { TableCellProps } from "@search/TableSearch";
import locale from "@bonliva-crm/locale";
import { ThemeType } from "@theme";
import {
  TimereportKitSupportSearchItemFragment,
  useBookingKitSupportSearch_GetCustomerBillingInstructionsLazyQuery
} from "@graphql";
import NationellaListMark from "@common/NationellaListMark";

const CustomerCol = ({
  rowData
}: TableCellProps<TimereportKitSupportSearchItemFragment>) => {
  const styles = useStyles();
  const [open, setOpen] = useState(false);
  const [getBillingInsctrustions, { data, loading }] =
    useBookingKitSupportSearch_GetCustomerBillingInstructionsLazyQuery({
      variables: {
        customerId: rowData.OrganizationRef.Id
      }
    });

  const billingInstructions = data?.customerById?.billingInstructions;
  const tooltipTitle =
    billingInstructions && !loading ? (
      <div className={styles.tooltipTitleWrap}>
        <div className={styles.tooltipLabel}>{locale.billingInstructions}:</div>
        <div className={styles.tooltipText}>{billingInstructions}</div>
      </div>
    ) : (
      ""
    );

  return (
    <div>
      <Tooltip
        arrow
        placement="top-start"
        title={tooltipTitle}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => {
          if (!open) {
            setOpen(true);

            if (!data) {
              getBillingInsctrustions();
            }
          }
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div>
            <Body display="block">{rowData.OrganizationRef.Name}</Body>
            <Body display="block">{rowData.HospitalRef.Name}</Body>
            {rowData.DepartmentsRefs.length > 0 && (
              <Body display="block">
                {rowData.DepartmentsRefs.map((x) => x.Name).join(", ")}
              </Body>
            )}
          </div>
          {rowData.isNationalProcurement && <NationellaListMark />}
        </div>
      </Tooltip>
    </div>
  );
};

const useStyles = makeStyles((theme: ThemeType) => ({
  tooltipTitleWrap: { maxWidth: 400 },
  tooltipLabel: { fontSize: 14 },
  tooltipText: { fontSize: 12 }
}));

export default CustomerCol;
